import React, { FC } from 'react';

import { Box, Grid } from '@mui/material';
import { useRouter } from 'next/router';
import { AccountDialNetworks } from 'src/v2/components/ui/accountDial/content/networkSwitch';
import { FullDialog } from 'src/v2/components/ui/fullDialog';

import { useSession } from '~components/hooks/useSession';

export const UnsupportedNetworkModal: FC = () => {
  const { network } = useSession();
  const router = useRouter();

  return (
    <FullDialog
      title="Unsupported Network"
      open={!network.isChainValid && router.asPath !== '/'}
      sx={{ justifyContent: 'center', alignItems: 'center' }}
      centerContent
    >
      <Grid container sx={{ justifyContent: 'center' }}>
        <Box width={300}>
          <AccountDialNetworks forceOpen={true} />
        </Box>
      </Grid>
    </FullDialog>
  );
};
